// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__1cVGv","logo":"loading_logo__1Blvu"};